export const commonLabels = {
	account: 'Back to member account',
	add: 'Add',
	back: 'Back',
	cancel: 'Cancel',
	checkout: 'Continue to checkout',
	continue: 'Continue',
	folx: 'Return to FOLX',
	next: 'Next',
	no: 'No',
	okay: 'Got it!',
	remove: 'Remove',
	return: 'Return',
	save: 'Save',
	search: 'Search',
	submit: 'Submit',
	yes: 'Yes',
};
